import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  
  constructor(
    public userService: UserService,
  ) {
    console.log(` is loggin ` + userService.isLoggedIn());
  }

  ngOnInit() {
    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts